export const regex_validation = {
  number_only: {
    value: /^-?[0-9]\d*(\.\d+)?$/,
    description: "The field should have digits only"
  }
}